import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteRiskyActivitiesInformation = new Map<string, ConfirmationData>([
    ["5559d511-33b1-407f-b6ce-458c53eb15c6|a1794961-3f8d-43c5-8007-6f8f1a36b4ed", { hidden: true }],
    ["b908fed1-921b-4dbb-ad68-153bc34547a3", { color: "skyblue",fontWeight: "bold" }],
    ["38a89aac-b0e9-4a7b-8753-aec98ae9f2ed|3bfc3c6b-7901-4569-8a03-093c8d904188", { hidden: true }],
    ["f3ce289d-7eba-4c3f-bf05-f82e865aa43a", { hidden: true }],
    ["c0c3a9e3-958f-4694-a002-8bf25b89a076", { hidden: true }],
    ["4fe77960-bd8c-46f8-b3a0-e89c636899ec", { hidden: true }],
    ["41cfcc04-0d68-461f-84d6-97cfeffcc6e0", { hidden: true }],
    ["e6daf75e-58f2-4244-aeaa-8fa43372900d", { hidden: true }],
    ["71a4328e-9e5e-48ff-bb33-65e51c29ca69|454cfcb1-d6bc-4e5b-bb19-2b85f6bae8df", { label: "Sí/No" }],
    ["f1146ff6-2aa7-418a-b219-b5febcd11db0|dbc2de67-429e-44ce-a172-0c9ac6c6a55a", { label: "Sí/No" }],
    ["2c1d529d-679c-4dbe-b2c2-3ed4544a6c6f|1d1e32fa-0063-4aa6-b6fd-c546713d5328", { label: "Sí/No" }],
    ["196a9cee-3032-409a-bc72-828901bc9eab|2e6febcd-d4d5-427a-918c-e1d728306203", { label: "Sí/No" }],
    ["60f6fa3a-f6ff-414c-b159-74f6a9b46b22|79a67db8-d2f5-4966-8052-7f45c3a432a9", { label: "Sí/No" }],
    ["a7580078-5f04-41b9-b91f-8d328fe3b95b", { color: "skyblue",fontWeight: "bold" }],
    ["3b9cbba8-091e-4cb7-9035-1582b89f47e1|ebaf4574-0e4d-4201-ae2e-e30a17c30b81", { hidden: true }],
    ["762decb1-3860-426e-89b7-a564afe3fc42|4977bb17-45d4-4619-917d-a38e2f3f856c", { hidden: true }],
    ["cba2440f-5e1b-463b-99cd-8890dcdc8762", { hidden: true }],
    ["81f68571-16e5-41d7-8b6a-4a037731acf4", { hidden: true }],
    ["af06e6b1-ed97-4f36-a551-4463f6d772a3|6db29b56-7ad1-4606-ab99-e199735dc942", { label: "Sí/No" }],
    ["d990a674-d382-44af-8395-139bd50c2ad2|f6e4e261-9ae2-4d59-9f24-a7759bbb6b30", { label: "Sí/No" }],
    ["df1db4f9-9fc3-4e03-9c59-9a74bcfcd525|39badfa1-9c29-4353-ace8-347c6d33c813", { label: "Sí/No" }],


]);



